import { render, staticRenderFns } from "./error-alert.vue?vue&type=template&id=06794ad8&scoped=true"
import script from "./error-alert.vue?vue&type=script&lang=js"
export * from "./error-alert.vue?vue&type=script&lang=js"
import style0 from "./error-alert.vue?vue&type=style&index=0&id=06794ad8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06794ad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06794ad8')) {
      api.createRecord('06794ad8', component.options)
    } else {
      api.reload('06794ad8', component.options)
    }
    module.hot.accept("./error-alert.vue?vue&type=template&id=06794ad8&scoped=true", function () {
      api.rerender('06794ad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/error-alert.vue"
export default component.exports